import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArtistName from "../../Components/Elements/ArtistName";
import Rerule from "~/Components/Icons/Rerule";

const TrackInfoHeader = styled.section`
  margin-bottom: 20px;

  h2 {
    display: inline-block;
    margin-bottom: 16px;
    width: 100%;
    .fa-icon {
      margin-right: 6px;
    }
  }
`;

const TrackFrom = styled.section`
  display: block;
  font-size: 16px;
  margin-left: 5px;
  font-style: italic;
`;

export const ReruleWrapper = styled.section`
  position: absolute;
  top: 0;
  right: 10px;
`;

const TrackHeader = ({ track, artistLink, trackLink, rerule }) => (
  <TrackInfoHeader>
    <h2>
      <FontAwesomeIcon icon="compact-disc" className="compact-disc fa-icon" />
      &ldquo;
      <span>
        {trackLink ? (
          <Link to={`/${track.id}`}>
            <span>{track.title}</span>
          </Link>
        ) : (
          <span>{track.title}</span>
        )}
      </span>
      &rdquo; by <ArtistName track={track} link={artistLink} />
      {rerule && (
        <ReruleWrapper className="hide-mobile">
          <Rerule trackId={track.id} />
        </ReruleWrapper>
      )}
    </h2>

    {track.album && (
      <TrackFrom>
        from <span>{track.album}</span>
      </TrackFrom>
    )}
  </TrackInfoHeader>
);

TrackHeader.defaultProps = {
  artistLink: false,
  trackLink: false,
  rerule: true,
};

export default TrackHeader;
